import validationMessages, {
  type ValidationMessagesDescriptor,
} from '@mfw/translations/ui/validationMessages';
import { useIntl } from '@mfw/components';
import React from 'react';

export function useValidationTranslation() {
  const { formatMessage } = useIntl();
  const translate = React.useCallback(
    (message?: unknown) => {
      if (!message) return undefined;
      const actualMessage =
        typeof message === 'string'
          ? message
          : typeof message === 'object' &&
              'message' in message &&
              typeof message.message === 'string'
            ? message.message
            : 'VALIDATION__Unknown';
      if (
        actualMessage.includes('VALIDATION__') &&
        validationMessages?.[
          actualMessage as keyof ValidationMessagesDescriptor
        ]
      )
        return formatMessage(
          validationMessages[
            actualMessage as keyof ValidationMessagesDescriptor
          ],
        );
      return actualMessage;
    },
    [formatMessage],
  );

  return { translate };
}
